// based on config returns the state function
import { getEnums, getEnumsLookup } from './utils'

export default ({ config, common }) => {
  let stateFn = () => {
    let state = {
      // one item can be active, this is ref to an item within items array
      activeItem: null,
      allItemsLoaded: false,
      config: config,
      // one of the editingItems
      currentlyEdited: null,
      // edited items are cloned and kept separately; we save changes only upon request
      // we use an array to allow multiple editing at once before saving (-> useful for batch/transactional save)
      editingItems: [
        // {
        //   item: { ... },
        //   existing: true/false,
        //   newItemIndex: ..
        // }
      ],
      // the filter is attached to the request as-is
      // updating filter triggers data reload when needed
      filter: null,
      // TODO: excel-style individual column filtering
      // filterOptions: [
      // {
      //   field: 'name',
      //   searchText: 'xxx',
      //   caseSensitive: false,
      //   partialMatch: true
      // }
      // ],
      // cache for all currently fetched items
      items: [],
      // last real error which happened (where we had an exception, not custom error message)
      lastError: null,
      // for some actions, we keep the actual promise and check if it's the same
      lastPromises: {},
      // list of ids of the checked items; not adding objects because we can make edits to them which will not appear
      // it's up to UI to choose if it will show the current editing state of item or the clean one
      markedItemKeys: [],
      // supports master-detail relationship (we check if master has been change when doing GET)
      masterActiveKey: null,
      // last get request
      // maximum # of visible items to cache; 0 = unlimited
      // TODO: maybe use strings like "10 MB" to limit based on memory usage
      maxShownItems: 0,
      // if we detect any errors/warning/infos, we push here so we can show them in UI
      messages: [],
      // user can add multiple new items at once, and only save them as needed
      // here we keep these newly created object
      // they will not be part of the regular items list
      newItems: [],
      // function which creates an "empty" object for new item
      // can also be object, in such case it will be cloned
      // tracking done by index
      // if left undefined, will be inferred from createXXX action
      // example: if we have createDocument action, we will instantiate a Document object as new
      newItemTemplate: null,
      pagination: {
        // page size (results #)
        limit: config.items.itemsPerPage,
        // offset used for infinite scroll
        offset: 0,
        // after key list is used by elastic search service for pagination
        // it is retrieved as part of response and sent back as is
        afterKeyList: []
      },
      // search by text or function (if doing client-side)
      // TODO: implement
      search: {
        text: null,
        caseSensitive: false,
        partialMatch: true,
        // list of fields to use search by text
        fields: []
      },
      // sort parameters
      sort: [
        // {
        //   field: 'name',
        //   direction: 'asc'
        // }
      ],
      // track subset of items which are shown in ui
      // this is useful to prevent fetching same item details multiple times
      // also serves as LRU list ([0] will be )
      shownItems: []
    }
    // each action gets a loading indication
    let linds = common.actionNames.reduce((acc, curr) => ({
      ...acc,
      [curr]: 0
    }), {})
    // also we have requests the same way
    let reqs = common.actionNames.reduce((acc, curr) => ({
      ...acc,
      [curr]: null
    }), {})

    let extendedState = {
      enums: getEnums(config),
      enumsLookup: getEnumsLookup(config),
      // detailed indicators - generated based on available actions
      loadingIndicators: linds,
      // latest request parameters for each action
      // used for checking if we should refresh the items etc.
      latestRequests: reqs
    }
    return {
      ...state,
      ...extendedState
    }
  }
  return stateFn
}
